import {Pipe, PipeTransform} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';

@Pipe({
    name: 'filterPackageSeq'
})
export class FilterPackageSeqPipe implements PipeTransform {

    transform(dtLines: any, dtLine: DetaillineDTOModel): DetaillineDTOModel[] {
        return dtLines.filter(item => {
            return item.line.contractDocumentNumber === dtLine.contractDocumentNumber
                && item.line.packageSeq === dtLine.packageSeq
                && item.line.packageName === dtLine.packageName;
        });
    }

}
